// extracted by mini-css-extract-plugin
export default {"wrapper":"type_wrapper__q+6ZC","name":"type_name__MTLt+","date":"type_date__vUkJs","whiteSpace":"type_whiteSpace__GQVPE"};